import BubbleCommon, {
  keywordDrillUrlExactSearchTips,
} from '@op/components/BubbleCommon';
import { keywordModalTextMap } from '@op/components/FilterCommon/constants/keyword';
import KeywordTips from '@op/components/FilterCommon/widgets/KeyWordsSelect/KeywordTips';
import { keywordsReplaceText } from '@op/components/FilterCommon/widgets/KeyWordsSelect/utils';
import { useRequestFontWebConfig } from '@op/hooks/useFrontWebConfig';
import { buriedBtnPoint } from '@op/operationLog/buriedPoint'; 
import React, { useMemo, useState } from 'react';
import { Form, Justify, RadioGroup, Radio, Button } from 'tea-component';
import SvgIcon from '@home/components/SvgIcon'; 
import useLanguage from '@op/hooks/useLanguage';
import { KeywordUrlTabType } from '@op/pages/AIAnalysisHub/KeywordAndURLAnalysis/types';
import { getKeywordPalaceholder } from '@op/components/FilterCommon/utils/keyword';
import TagList from '@op/components/FilterCommon/components/TagList';
import AutoTextAreaBox from '@op/components/FilterCommon/components/AutoTextAreaBox';

export default function KeywordsOptions({
  gameInfo,
  setKeywordCustomInput,
  keywordSearchType,
  setKeywordSearchType,
  grammarTrue,
  grammarText,
  keywordCustomInput,
  tab,
}: {
  gameInfo: any; 
  keywordSearchType: string;
  keywordCustomInput: string;
  setKeywordSearchType: (value: any) => void;
  grammarText: string;
  grammarTrue: boolean;
  setKeywordCustomInput: (value: string) => void;
  tab?: KeywordUrlTabType;
}) {
  const { formatMessage, isEn } = useLanguage();
  const { keyword_analysis_shortcut = [] } = useRequestFontWebConfig({
    keys: [{ key: 'keyword_analysis_shortcut' }],
    gameInfo,
  });
  const [showKeyword, setShowKeyword] = useState(false);

  const showKeywordFilter = useMemo(() => {
    if (tab === 'keyword') return true;
    return showKeyword;
  }, [showKeyword, tab]);

  return (
    <Form.Item
      label={
        <BubbleCommon
          content={<KeywordTips isBubble></KeywordTips>}
          tipsMap={undefined}
          placement="top"
        >
          {formatMessage({ id: 'Keywords' })}
        </BubbleCommon>
      }
    >
      {tab === 'url' && (
        <Button
          className="dbo-button-show-all"
          type="link"
          onClick={() => setShowKeyword(!showKeyword)}
        >
          {formatMessage({ id: showKeyword ? 'Close' : 'Show' })}
          <SvgIcon
            className={showKeyword ? 'dbo-show-all' : ''}
            type="fill-icon-arrow"
          />
        </Button>
      )}
      <div
        className={tab === 'url' ? 'dbo-keywords-analysis-url' : ''}
        style={{ display: showKeywordFilter ? 'block' : 'none' }}
      >
        <Justify
          className="dbo-analysis-url-row"
          top
          left={
            <TagList
              list={keyword_analysis_shortcut}
              setValue={setKeywordCustomInput}
              isEn={isEn}
            ></TagList>
          }
          right={
            <RadioGroup
              value={keywordSearchType}
              onChange={(value: string) => {
                setKeywordSearchType(value as any);
                buriedBtnPoint('KeywordSearchType', value);
              }}
            >
              {/* <Radio name="extend">
                        <BubbleCommon
                          showIcon={false}
                          tipsMap={keywordDrillUrlExtendedSearchTips}
                          placement="top"
                        >
                          {formatMessage({ id: keywordModalTextMap.extend })}
                        </BubbleCommon>
                      </Radio> */}
              <Radio name="exact">
                <BubbleCommon
                  showIcon={false}
                  tipsMap={keywordDrillUrlExactSearchTips}
                  placement="left"
                >
                  {formatMessage({ id: keywordModalTextMap.exact })}
                </BubbleCommon>
              </Radio>
            </RadioGroup>
          }
        />
        <AutoTextAreaBox
          value={keywordCustomInput}
          replaceText={keywordsReplaceText}
          grammarTrue={grammarTrue}
          grammarText={formatMessage(grammarText)}
          setValue={setKeywordCustomInput}
          placeholder={getKeywordPalaceholder(formatMessage)}
        ></AutoTextAreaBox>
      </div>
    </Form.Item>
  );
}
